import { render, staticRenderFns } from "./MonthlyBudget.vue?vue&type=template&id=727ae980"
import script from "./MonthlyBudget.vue?vue&type=script&lang=js"
export * from "./MonthlyBudget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports